module.exports = __webpack_public_path__ + "static/img/logo-if-form.eac5b8b0.svg";